<template>
  <div class="layout-container">
    <Sidebar />
    <div class="left-container">
      <Topbar />
      <main class="content" id="main-content">
        <header class="page-heading">
          <div class="page-title-block">
            <span class="page-icon"><NavigationIcon :route="$route.path" /></span>
            <div><nav class="page-breadcrumb" aria-label="مسیر صفحه"><router-link to="/dashboard">پنل مدیریت</router-link><span aria-hidden="true">/</span><span>{{ title }}</span></nav><h1>{{ title }}</h1></div>
          </div>
          <router-link v-if="$route.name !== 'dashboard'" to="/dashboard" class="dashboard-link"><NavigationIcon route="/dashboard" />داشبورد</router-link>
        </header>
        <MenuTabs />
        <div class="contdainer"><router-view /></div>
      </main>
    </div>
  </div>
</template>
<script>
import Sidebar from './Sidebar.vue';
import Topbar from './Topbar.vue';
import NavigationIcon from '../components/NavigationIcon/index.vue';
import MenuTabs from './MenuTabs.vue';
export default {
  name: 'AdminLayout',
  components: { Sidebar, Topbar, NavigationIcon, MenuTabs },
  computed: { title() { return this.$route.meta.title || 'مدیریت'; } },
};
</script>
<style scoped>
.layout-container { display: flex; height: 100vh; height: 100dvh; overflow: hidden; }
.left-container { flex: 1; min-width: 0; overflow-y: auto; background: var(--surface-bg); }
.content { padding: 22px 32px 32px; max-width: 1680px; margin: 0 auto; }
.page-heading { display: flex; align-items: center; justify-content: space-between; gap: 16px; margin-bottom: 20px; }
.page-title-block { display: flex; align-items: center; gap: 14px; min-width: 0; }
.page-icon { display: grid; place-items: center; width: 44px; height: 44px; flex: none; border-radius: var(--r-sm); background: var(--navy-900); color: var(--teal-300); box-shadow: 3px 3px 0 var(--amber-500); }
.page-breadcrumb { display: flex; align-items: center; gap: 8px; color: var(--text-3); font-size: 11.5px; line-height: 1.4; }
.page-breadcrumb a { color: var(--text-3); text-decoration: none; }
.page-breadcrumb a:hover { color: var(--teal-700); }
h1 { font-size: 21px; font-weight: 900; margin: 3px 0 0; color: var(--text); line-height: 1.45; }
.dashboard-link { display: inline-flex; align-items: center; gap: 8px; color: var(--text-2); font-size: 12px; font-weight: 700; padding: 9px 14px; background: var(--surface); border: 1px solid var(--line-strong); border-radius: var(--r-xs); transition: border-color .15s, box-shadow .2s var(--ease-out); }
.dashboard-link:hover { color: var(--text); border-color: var(--navy-900); box-shadow: 2px 2px 0 var(--navy-900); }
.dashboard-link .navigation-icon { width: 16px; height: 16px; flex-basis: 16px; }
@media (max-width: 1100px) { .content { padding: 18px 24px 24px; } }
@media (max-width: 767px) { .content { padding: 20px 16px; } h1 { font-size: 18px; } .page-heading { align-items: flex-start; gap: 10px; } .page-icon { display: none; } .dashboard-link { padding: 8px; } }
</style>
